(function () {
    "use strict";

    angular.module("app").component("habilCpJustificationView", {
        templateUrl: '@/contact-person/request/cp-justification-view.template.html',
        bindings: { justification: '<' },
    });
})();